export const INTL_TEXTS: Intl = {
  eng: {},
  ptbr: {
    headerTitle: '',
    firstDeposit: 'Depositar dinheiro',
    useYourPixkey: 'Use sua chave Pix para colocar dinheiro na conta. É gratuito e cai na hora.',
    wasCreatedYourkey:
      'Criamos sua chave. Quem te pagar verá seu nome completo e alguns dígitos do seu CPF',
    btnCopyKey: 'Copiar chave',
    btnUseAnotherKey: 'Usar outra chave',
    copyKeyToast: 'Chave copiada',
    pixTypeCpf: 'CPF',
    pixTypeCnpj: 'CNPJ',
    pixTypePhone: 'Celular',
    pixTypeEmail: 'E-mail',
    pixTypeEvp: 'Aleatória',
    pixTypeRandom: 'Aleatória',
    errorTitle: 'Houve um erro por aqui',
    errorDescription: 'Por favor, tente novamente mais tarde.',
    errorButtonText: 'Entendi',
  },
}
